export default __webpack_public_path__ + "static/media/Nissan-BLK.39aa7cd8.jpg";